<template>
  <div class="admin-brand">
    <section class="hero is-light">
      <div class="hero-body">
        <div class="container">
          <router-link :to="{ name: 'admin' }">Back</router-link>
          <div class="level">
            <div class="level-left">
              <h1 class="title level-item">Admin</h1>
            </div>
            <div class="level-right">
              <div class="level-item">
                <a class="button is-danger" :class="{ 'is-loading': saving }" @click="saveButtonPressed">Save</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="section">
      <div class="container">
        <form @submit.prevent="formSubmit($event)">
          <div class="columns is-multiline">
            <div class="column is-one-third">
              <div class="field">
                <label class="label">Title</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Title" v-model="brand.title">
                </div>
              </div>
              <div class="field">
                <label class="label">URL (for footer)</label>
                <div class="control">
                  <input class="input" type="text" placeholder="https://" v-model="brand.url">
                </div>
              </div>
              <div class="field">
                <label class="label">Background colour</label>
                <div class="field has-addons">
                  <div class="control">
                    <input class="input" type="text" placeholder="#fff" v-model="brand.colour">
                  </div>
                  <div class="control color-display" :style="{ 'background-color': brand.colour }"></div>
                </div>
              </div>
            </div>
            <div class="column is-two-thirds">
              <div class="field">
                <label class="label">Description</label>
                <div class="control">
                  <vue-ckeditor v-model="brand.descriptionOne" :config="config" />
                </div>
              </div>
            </div>
            <div class="column">
              <h3 class="title is-6">Ingredients</h3>
              <div class="tags">
                <div class="tag" v-for="(ingredient, i) in brand.ingredients" :key="i">{{ ingredient }}
                  <span class="delete is-small" @click.prevent="deleteIngredient(i)"></span>
                </div>
              </div>
              <div class="field has-addons">
                <div class="control">
                  <input class="input is-small" type="text" placeholder="Add ingredient" v-model="newIngredient" @keyup.13="addIngredient()">
                </div>
                <div class="control">
                  <a class="button is-small is-info" @click.prevent="addIngredient()">Add</a>
                </div>
              </div>
            </div>
            <div class="column is-one-third">
              <div class="field">
                <label class="label">Description two</label>
                <div class="control">
                  <vue-ckeditor v-model="brand.descriptionTwo" :config="config" />
                </div>
              </div>
            </div>
            <div class="column is-one-third">
              <div class="field">
                <label class="label">Description three</label>
                <div class="control">
                  <vue-ckeditor v-model="brand.descriptionThree" :config="config" />
                </div>
              </div>
            </div>
            <div class="column is-one-third">
              <div class="box">
                <h3 class="title is-6">Logo</h3>
                <div class="file-uploader loader logoUrl"></div>
                <img class="admin__image" :src="brand.logoUrl">
                <div class="field">
                  <div class="file">
                    <label class="file-label">
                      <input class="file-input" type="file" name="resume" @change="uploadFile($event, 'logoUrl')">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload"></i>
                        </span>
                        <span class="file-label">Choose a file…</span>
                      </span>
                    </label>
                  </div>
                  <div class="help">~ 500px wide</div>
                </div>
              </div>
            </div>
            <div class="column is-one-third">
              <div class="box">
                <h3 class="title is-6">Logo (white)</h3>
                <div class="file-uploader loader logoWhiteUrl"></div>
                <img class="admin__image" :src="brand.logoWhiteUrl">
                <div class="field">
                  <div class="file">
                    <label class="file-label">
                      <input class="file-input" type="file" name="resume" @change="uploadFile($event, 'logoWhiteUrl')">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload"></i>
                        </span>
                        <span class="file-label">Choose a file…</span>
                      </span>
                    </label>
                  </div>
                  <div class="help">~ 500px wide</div>
                </div>
              </div>
            </div>
            <div class="column is-one-third">
              <div class="box">
                <h3 class="title is-6">Product image</h3>
                <div class="file-uploader loader productImageUrl"></div>
                <img class="admin__image" :src="brand.productImageUrl">
                <div class="field">
                  <div class="file">
                    <label class="file-label">
                      <input class="file-input" type="file" name="resume" @change="uploadFile($event, 'productImageUrl')">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload"></i>
                        </span>
                        <span class="file-label">Choose a file…</span>
                      </span>
                    </label>
                  </div>
                  <div class="help">900 x 900</div>
                </div>
              </div>
            </div>
            <div class="column is-one-third">
              <div class="box">
                <h3 class="title is-6">Banner image</h3>
                <div class="file-uploader loader bannerImageUrl"></div>
                <img class="admin__image" :src="brand.bannerImageUrl">
                <div class="field">
                  <div class="file">
                    <label class="file-label">
                      <input class="file-input" type="file" name="resume" @change="uploadFile($event, 'bannerImageUrl')">
                      <span class="file-cta">
                        <span class="file-icon">
                          <i class="fas fa-upload"></i>
                        </span>
                        <span class="file-label">Choose a file…</span>
                      </span>
                    </label>
                  </div>
                  <div class="help">1170px wide</div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {db, storage} from '@/firebase.js'
import VueCkeditor from 'vue-ckeditor2'

export default {
  props: ['brands', 'index'],
  components: { VueCkeditor },
  data() {
    return {
      newIngredient: null,
      config: {
        toolbar: [
          ['Bold', 'Italic', 'Underline', 'Link']
        ],
        height: 100
      },
      saving: false
    }
  },
  computed: {
    brand() {
      return this.brands[this.index]
    }
  },
  methods: {
    saveButtonPressed() {
      this.saving = true
      
      db.collection('app').doc('appData').update({
        brands: this.brands
      })
      .then(() => {
        alert('Save successful')
      })
      .catch(() => {
        alert('Save failed')
      })
      .finally(() => {
        this.saving = false
      })
    },
    uploadFile(e, property) {
      var file = e.target.files[0]
      const nameFormat = file.name.split('.')
      const name = nameFormat[0] + '-' + Date.now() + '.' + nameFormat[1]
      const metadata = { contentType: file.type }

      document.querySelector('.'+property).classList.add('shown')

      storage.ref().child(`partners/${name}`).put(file, metadata)
      .then(snapshot => snapshot.ref.getDownloadURL())
      .then(url => {        
        this.brand[property] = url
        document.querySelector('.'+property).classList.remove('shown')
      })
    },
    addIngredient() {
      this.brand.ingredients.push(this.newIngredient)
      this.newIngredient = null
    },
    deleteIngredient(i) {
      this.brand.ingredients.splice(i, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  margin-bottom: 0;
}

.color-display {
  width: 50px;
}
</style>
